import { Component, OnInit } from '@angular/core';
import { NavParams } from '@ionic/angular';
import { PlacesStore } from '../../stores/places.store';

const localStorageSettingsKey = "placesSettings"
  
@Component({
  selector: 'app-places-settings',
  templateUrl: './places-settings.component.html',
  styleUrls: ['./places-settings.component.scss'],
})
export class PlacesSettingsComponent  implements OnInit {
  tags = this.placesStore.uniquePlacesTagsAndAddresses().tags
  countries = this.placesStore.uniquePlacesTagsAndAddresses().countries
  cities = this.placesStore.uniquePlacesTagsAndAddresses().cities
  streets = this.placesStore.uniquePlacesTagsAndAddresses().streets
  floorLabels = this.placesStore.uniquePlacesTagsAndAddresses().floorLabels
  floorNumbers = this.placesStore.uniquePlacesTagsAndAddresses().floorNumbers
  locations = this.placesStore.uniquePlacesTagsAndAddresses().locations

  saveLocation: any;
  comingFrom: string = 'default';
  constructor(
    private navParams: NavParams,
    public placesStore: PlacesStore
  ) { 
    this.saveLocation = localStorage.getItem(localStorageSettingsKey)
  }

  ngOnInit() {  
    this.comingFrom = this.navParams.get('comingFrom')
  }
  ngOnDestroy(){

  }



  handleFilterChange(event) {
    this.updateFilterCriteria(event)
  }
  
  updateFilterCriteria(event) {
    let {country,city,street} = this.placesStore.filterCriteria()
    switch (event.target.name){
      case "placeTag" : 
      this.placesStore.setFilterCriteria({...this.placesStore.filterCriteria(),tag:event.target.value})
        break;
      case "country" : 
        this.cities = Object.keys(this.locations[event.target.value].cities)
        this.streets = []
        this.floorLabels = []
        this.floorNumbers = []
        this.placesStore.setFilterCriteria({...this.placesStore.filterCriteria(),country:event.target.value,city:"",street:"",floor:"",floorNumber:""})
        break;
      case "city" : 
        this.streets = Object.keys(this.locations[country].cities[event.target.value].streets)
        this.floorLabels = []
        this.floorNumbers = []
        this.placesStore.setFilterCriteria({...this.placesStore.filterCriteria(),city:event.target.value,street:"",floor:"",floorNumber:""})
        break;
      case "street" : 
        this.floorLabels = Object.keys(this.locations[country].cities[city].streets[event.target.value].floorLabels)
        this.floorNumbers = []
        this.placesStore.setFilterCriteria({...this.placesStore.filterCriteria(),street:event.target.value,floor:"",floorNumber:""})
        break;
      case "floor" : 
        this.floorNumbers = this.locations[country].cities[city].streets[street].floorLabels[event.target.value].floorNumbers
        this.placesStore.setFilterCriteria({...this.placesStore.filterCriteria(),floor:event.target.value,floorNumber:""})
        break;
    }
    if(this.saveLocation) {
      localStorage.setItem(localStorageSettingsKey,JSON.stringify(this.placesStore.filterCriteria()))
    } 
  }

  resetFilterCriteria() {
    this.placesStore.clearFilterCriteria()
    this.saveLocation = false;
    localStorage.removeItem(localStorageSettingsKey)
  }

  handleSaveLocationChange(event) {
    if(event.target.checked) {
      this.saveLocation = true
      localStorage.setItem(localStorageSettingsKey,JSON.stringify(this.placesStore.filterCriteria()))
    } else {
      this.saveLocation = false
      localStorage.removeItem(localStorageSettingsKey)
    }
    
  }



}
